import { makeGenericActionCreator, makeActionCreator } from "../utils/reduxUtils";
import API from "../utils/API";
import { IIntercomSettings } from "../models/Intercom";

type allowedIntercomField = "name" | "adminId";
export const SET_INTERCOM_FIELD = "SET_INTERCOM_FIELD";
export const setIntercomField = makeGenericActionCreator<allowedIntercomField>(SET_INTERCOM_FIELD);

export const RESET_INTERCOM_STATE = "RESET_INTERCOM_STATE";
export const resetIntercomState = makeActionCreator(RESET_INTERCOM_STATE);

export const FETCH_INTERCOM_SETTINGS_REQUEST = "FETCH_INTERCOM_SETTINGS_REQUEST";
export const FETCH_INTERCOM_SETTINGS_SUCCESS = "FETCH_INTERCOM_SETTINGS_SUCCESS";
export const FETCH_INTERCOM_SETTINGS_FAILURE = "FETCH_INTERCOM_SETTINGS_FAILURE";

export const UPDATE_INTERCOM_SETTINGS_REQUEST = "UPDATE_INTERCOM_SETTINGS_REQUEST";
export const UPDATE_INTERCOM_SETTINGS_SUCCESS = "UPDATE_INTERCOM_SETTINGS_SUCCESS";
export const UPDATE_INTERCOM_SETTINGS_FAILURE = "UPDATE_INTERCOM_SETTINGS_FAILURE";


export const fetchIntercomSettings = () => {
  return {
    types: [FETCH_INTERCOM_SETTINGS_REQUEST, FETCH_INTERCOM_SETTINGS_SUCCESS, FETCH_INTERCOM_SETTINGS_FAILURE],
    callAPI: () => API.fetchIntercomSettings()
  }
}

export const updateIntercomSettings = (payload: IIntercomSettings) => {
  return {
    types: [UPDATE_INTERCOM_SETTINGS_REQUEST, UPDATE_INTERCOM_SETTINGS_SUCCESS, UPDATE_INTERCOM_SETTINGS_FAILURE],
    callAPI: () => API.updateIntercomSettings(payload)
  }
}